import StatisticsContainer from './StatisticsContainer'

export default function StatisticsScreen() {
    return <StatisticsContainer />
}
